module.exports = __webpack_public_path__ + "static/media/AddressesOfBaithaksOfShriGusaiJiShriVitthalnathJiShriGokulnathji.2138577e.pdf";